import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(4),
  },
}));

export default useStyles;
